export enum ModuleCategory {
    General = 0,
    WebDev = 1,
    Design = 2,
    AppDev = 3,
    Animation = 4,
    Foundation = 5
}

export const moduleCategories = Object.values(ModuleCategory).filter((v) => !isNaN(Number(v))) as number[];